import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { Desk } from 'src/app/models/turns-models/desk.model';
import { Subscription } from 'rxjs';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-turns-form-desks-card',
  templateUrl: './turns-form-desks-card.component.html',
  styleUrls: ['./turns-form-desks-card.component.scss']
})
export class TurnsFormDesksCardComponent implements OnInit, OnDestroy {

  @Input() form: FormBasic;
  @Input() desks: Array<Desk>;
  selectedDesks;
  updateFormInfoSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  public duallistboxOutputEventReceiver(selectedDesks) {
    const aux = new Array();
    for (const d of selectedDesks) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedDesks = aux;
      this.updateFormDesks();
    }
  }

  public updateFormDesks() {
    const validation = this.validateForm();
    if (validation === true) {
      this.updateFormInfoSubscription = this.formsTurnsService.updateFormDesks(this.form.InternalId, this.form.Active, this.selectedDesks).subscribe(
        (res) => {
          this.formsTurnsService.refreshForm();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
          this.formsTurnsService.refreshForm();
        }
      );
    } else {
      this.formsTurnsService.refreshForm();
      this.snackbarService.open(validation, 'error');
    }
  }

  public validateForm() {
    if (!this.selectedDesks || !(this.selectedDesks.length > 0)) {
      return 'turns-page.snackbar messages.at least one desk form error';
    } else {
      return true;
    }
  }

  ngOnDestroy() {
    if (this.updateFormInfoSubscription) { this.updateFormInfoSubscription.unsubscribe(); }
  }
}
